@for (banner of banners; track banner) {
  <section class="col-xs-12 wonderfluimg" id="home_loginsection" role="img" aria-label="Healthcare professional silhouette" style="background-image: url('{{getImage(banner?.media)}}');">
    <div class="bannerHeader">
    <div class="wrappercontainer">
      <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
      <div class="headLine" [innerHTML]="banner.headline"></div>
    </div>
  </div>
  </section>
}


